module.exports = __webpack_public_path__ + "static/media/banner_jetx.3032e928.png";